export default __webpack_public_path__ + "static/media/shield4.3fbb2866.png";